import cnhMM from "./cnh-mm.json";
import deDE from "./de-de.json";
import enGB from "./en-gb.json";
import enUS from "./en-us.json";
import esEC from "./es-ec.json";
import esPR from "./es-pr.json";
import esUS from "./es-us.json";
import frCA from "./fr-ca.json";
import frFR from "./fr-fr.json";
import frUS from "./fr-us.json";
import htUS from "./ht-us.json";
import idID from "./id-id.json";
import itIT from "./it-it.json";
import jaJP from "./ja-jp.json";
import koKR from "./ko-kr.json";
import myMM from "./my-mm.json";
import nlNL from "./nl-nl.json";
import noNO from "./no-no.json";
import ptBR from "./pt-br.json";
import ptPT from "./pt-pt.json";
import ruRU from "./ru-ru.json";
import svSE from "./sv-se.json";
import thTH from "./th-th.json";
import viVN from "./vi-vn.json";
import zhCN from "./zh-cn.json";
import zhHant from "./zh-hant.json";

export default {
  "cnh-mm": {data: cnhMM, name: "Hakha Chin"},
  "de-de": {data: deDE, name: "German"},
  "en-gb": {data: enGB, name: "English (GB)"},
  "en-us": {data: enUS, name: "English (US)"},
  "es-ec": {data: esEC, name: "Spanish (Ecuador)"},
  "es-pr": {data: esPR, name: "Spanish (Puerto Rico)"},
  "es-us": {data: esUS, name: "Spanish"},
  "fr-ca": {data: frCA, name: "French (Canadian)"},
  "fr-fr": {data: frFR, name: "French (France)"},
  "fr-us": {data: frUS, name: "French"},
  "ht-us": {data: htUS, name: "Creole"},
  "id-id": {data: idID, name: "Indonesian"},
  "it-it": {data: itIT, name: "Italian"},
  "ja-jp": {data: jaJP, name: "Japanese"},
  "ko-kr": {data: koKR, name: "Korean"},
  "my-mm": {data: myMM, name: "Burmese (Myanmar [Burma])"},
  "nl-nl": {data: nlNL, name: "Dutch"},
  "no-no": {data: noNO, name: "Norwegian"},
  "pt-br": {data: ptBR, name: "Portuguese (Brazil)"},
  "pt-pt": {data: ptPT, name: "Portuguese"},
  "ru-ru": {data: ruRU, name: "Russian"},
  "sv-se": {data: svSE, name: "Swedish"},
  "th-th": {data: thTH, name: "Thai"},
  "vi-vn": {data: viVN, name: "Vietnamese"},
  "zh-cn": {data: zhCN, name: "Chinese (Simplified)"},
  "zh-hant": {data: zhHant, name: "Chinese (Traditional)"}
};
